import React from 'react';
import { useLottie, Lottie } from 'react-lottie-hook';
import animationData from './loader/Loader.json';
// import '../../containers/Join/components/MultiStepForm.scss';

const MySpinner = ({styleObj, isHideText}) => {
  const [lottieRef, { isPaused, isStopped }, controls] = useLottie({
    renderer: 'svg',
    rendererSettings: {
      progressiveLoad: false,
    },
    animationData,
  });

  const style2 = {
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    top: '0',
    left: '0',
    opacity: '0.8',
    zIndex: '998',
    height: '100%',
    width: '100%',
  };

  const styleText = {
    direction: 'rtl',
    textAlign: 'center',
    fontFamily: 'ploni',
    fontSize: '26px'
  }

  const mainStyle = styleObj ? {...style2, ...styleObj} : style2;

  return (
    <div style={mainStyle}>
        <Lottie lottieRef={lottieRef} width={200} height={280} />
        <div style={styleText}>
          {!isHideText ? 
          <span>אנא המתן...</span>
        : null }
          
        </div>
    </div>
  );
};

export default MySpinner;




// import React from 'react';

// const MySpinner = () => {
//   const style = {
//     position: 'fixed',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: '100%',
//     height: '100%',
//     alignSelf: 'center'
//   };
//   const style2 = {
//     position: 'fixed',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     top: '0',
//     left: '0',
//     background: '#666',
//     opacity: '0.8',
//     zIndex: '998',
//     height: '100%',
//     width: '100%'
//   };
//   const style3 = {
//     display: 'inline-block',
//     textalign: 'left',
//     backgroundColor: '#000',
//     color: '#f5f5f5',
//     padding: '20px',
//     borderRadius: '4px',
//     fontSize: '20px',
//     fontWeight: '700'
//   };
//   const style4 = {
//     position: 'absolute',
//     top: '35%',
//     left: '0',
//     right: '0',
//     height: '0',
//     textAlign: 'center',
//     zIndex: '10001'
//   };
//   return (
//     <div style={style2}>
//       <div style={style4}>
//         <div style={style3}>אנא המתן...</div>
//       </div>
//     </div>
//   );
// };

// export default MySpinner;